import { type LoaderFunctionArgs } from "react-router";

import {
  DashboardAgentsDetailsDocument,
  type DashboardAgentsDetailsQuery,
  type DashboardAgentsDetailsQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

import { requireParam } from "@application/hooks/use_required_param";

export const DASHBOARD_AGENTS_DETAILS_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const { data } = await client.query<
    DashboardAgentsDetailsQuery,
    DashboardAgentsDetailsQueryVariables
  >({
    query: DashboardAgentsDetailsDocument,
    variables: { id: requireParam(props.params, "id") },
  });

  return data;
};
